<app-vertical *ngIf="isVerticalLayoutRequested()"></app-vertical>
